import { parseJwt } from './encodeDecodeUtils';
import { CookieName, cookieValue } from './cookieUtils';
import dayjs from 'dayjs';
import { Categories, Item, PriceType } from '../../../../interfaces/src/lib/interfaces/index';
import { getActiveSession } from '../session/SessionsUtils';

declare global {
  interface Window {
    pageViewContent: Record<string, any>;
    exchangeTriggered?: boolean;
  }
}

declare global {
  interface Window {
    pageViewContent: Record<string, any>;
  }
}

declare global {
  interface Window {
    pageViewContent: Record<string, any>;
  }
}

declare global {
  interface Window {
    pageViewContent: Record<string, any>;
    didomiOnReady?: any[];
  }
}

export function getEmailByJwtAuthTokenCookie(): string {
  let isPartnership =
    document.querySelector('meta[name="siteType"]')?.getAttribute('content')?.toLowerCase() ===
    'partnership';
  let isB2C =
    document.querySelector('meta[name="siteType"]')?.getAttribute('content')?.toLowerCase() ===
    'b2c';
  let email: string | undefined;
  if (isPartnership) {
    email = getActiveSession().email;
  } else if (isB2C) {
    const cookie = cookieValue(CookieName.B2CW);
    if (cookie) {
      email = parseJwt(cookie)?.email;
    }
  }
  return email ? email : '';
}

type GenericObject = { [key: string]: any };
export const arrayOfObjectsToString = (arr: GenericObject[], key = 'value'): string => {
  if (arr.length === 0) {
    return 'any';
  }

  const values = arr.map((obj) => obj[key]);
  const uniqueValues = Array.from(new Set(values));

  return uniqueValues.join(', ')?.toLowerCase();
};

function convertDateFormat(dateString: string): string {
  const [startDateStr, endDateStr] = dateString.split(/(?<=\d{4})\s+/);

  const startDate = dayjs(startDateStr, 'DD MMM YYYY');
  const endDate = dayjs(endDateStr, 'DD MMM YYYY');

  if (!startDate.isValid() || !endDate.isValid()) {
    throw new Error('Invalid date format');
  }

  const startDateFormatted = startDate.format('YYYY-MM-DD');
  const endDateFormatted = endDate.format('YYYY-MM-DD');

  return `${startDateFormatted} to ${endDateFormatted}`;
}

export const concatStartAndEndDate = (
  selectedDates: (string | null)[],
  selectedPeriods: string[]
): string => {
  let dates;

  if (selectedDates[0] && selectedDates[1]) {
    dates = selectedDates.map((str) => dayjs(str?.split(' ')[0]).format('YYYY-MM-DD'));
    return dates?.join(' to ');
  } else if (selectedPeriods && selectedPeriods.length > 0) {
    const periodsArray: string[] = [];
    selectedPeriods?.map((period) => {
      // Define the keywords to be removed
      const excludedKeywords = [
        'Winter',
        'Christmas',
        'Easter',
        'Spring',
        'Summer',
        'Autumn',
        'Fall',
      ];
      const regex = new RegExp(`\\b(${excludedKeywords.join('|')})\\b`, 'gi');
      const cleanedPeriod = period.replace(regex, '').trim();

      // Convert and add to the array
      const outputString = convertDateFormat(cleanedPeriod);
      periodsArray?.push(outputString);
    });

    return periodsArray.join(', ')?.toLowerCase();
  } else {
    return 'any';
  }
};

export const getQueryParam = (param: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

export const getShipByCruiseId = (cruiseId: string | null): string => {
  if (cruiseId && cruiseId.length >= 2) {
    return cruiseId.substring(0, 2);
  }
  return '';
};

export const concatStringWithSemiColon = (arr: GenericObject[], key = 'value'): string => {
  if (arr.length === 0) {
    return '';
  }

  const values = arr.map((obj) => obj[key]);
  const uniqueValues = Array.from(new Set(values));

  return uniqueValues.join(':')?.toLowerCase();
};

export const retrieveExperience = (category: Categories | null): string => {
  if (category) {
    const experience = category?.items?.find((item: Item) => item?.code.startsWith('EXP'));
    if (experience?.description?.toLowerCase().includes('msc yacht club')) {
      return 'msc yacht club';
    }
    return experience?.description?.split(' ')[0]?.toLowerCase() || '';
  }
  return '';
};

export const getMatchingPriceType = (
  priceTypes: PriceType[],
  queryPriceType: string | undefined
) => {
  return priceTypes?.find(
    (priceType: { priceType: string }) =>
      priceType.priceType?.toLowerCase() === queryPriceType?.toLowerCase()
  );
};

export const isBooking = () => {
  return window?.pageViewContent?.['page_category'] === 'booking';
};
